export default __webpack_public_path__ + "static/media/monkey-3.3e2a23f9.png";